import React from "react";
import styles from "./chart-title.scss";

const ChartTitle = ({ children }) => {
  return <div className={styles.chartTitle}>{children}</div>;
};

export default ChartTitle;
